import { forEach } from 'lodash';

export const convertFileToImage = (file, callback) => {
  var reader = new FileReader();
  reader.onload = callback;
  reader.readAsDataURL(file);
};

export const resetImageStyle = (imageStyle, profileImageStyles) => {
  imageStyle.removeProperty('top');
  imageStyle.removeProperty('left');
  imageStyle.setProperty('visibility', 'hidden');
  imageStyle.setProperty('width', profileImageStyles.width);
  imageStyle.setProperty('height', profileImageStyles.height);
};

const wideImageStyle = {
  height: '100%',
  width: 'auto'
};

const tallImageStyle = {
  width: '100%',
  height: 'auto'
};

export const adjustImageStyling = (image) => {
  image.onload = function(event) {
    const { naturalWidth, naturalHeight } =  event.target;

    if (naturalWidth > naturalHeight) {
      updateImageStyling({
        ...wideImageStyle,
        left: determineLeftPosition(event.target),
      }, image.style);
    } else {
      updateImageStyling({
        ...tallImageStyle,
        top: determineTopPosition(event.target),
      }, image.style);
    }
  };
};

const determineLeftPosition = (image) => {
  const { naturalWidth, naturalHeight, width, height } =  image;
  const ratio = height / naturalHeight;
  const adjustedWidth = naturalWidth * ratio;
  return (adjustedWidth / 2 - (width / 2)) * -1 + 'px';
};

const determineTopPosition = (image) => {
  const { naturalWidth, naturalHeight, width, height } =  image;
  const ratio = width / naturalWidth;
  const adjustedHeight = naturalHeight * ratio;
  return (adjustedHeight / 2 - (height / 2)) * -1 + 'px';
};

const updateImageStyling = (style, imageStyle) => {
  forEach({...style, visibility: 'visible'}, (value, style) => {
    imageStyle.setProperty(style, value);
  });
};



// WEBPACK FOOTER //
// ./src/advocate/onboarding/components/profile_image_helper.js